//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
import TransitionExpand from "../../global/transitions/Expand";
import FilterItem from "./FilterItem";
import FilterGroup from "./FilterGroup";

export default {
  name: "SearchFilters",
	props: {
		executeSearch: Function,
		setFilterValue: Function,
		setLoadingValue: Function,
	},
	components: {
		TransitionExpand,
		FilterItem,
		FilterGroup,
	},
	data() {
		return {
			url: null,
			mobileActive: false,
			screenWidth: window.innerWidth,
		}
	},
	computed: {
		...mapGetters([
			"filters"
		]),
		visibleFilterGroups() {
			return this.filters.filter(f => f.visible);
		},
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		filterSelectedValue(filter) {
			let options = filter.filters;
			return options.some(o => o.selected) ?
				options.find(o => o.selected) :
				false;
		},
		toggleMobile() {
			const filtersDropdown = this.$el.querySelector(".filters__filters");
			const start = filtersDropdown.offsetHeight;
			this.mobileActive = !this.mobileActive;
			filtersDropdown.classList.toggle("mobileActive")
			const end = filtersDropdown.offsetHeight;
			console.log("animating:", start, end)
			filtersDropdown.animate([
				{height: `${start}px`},
				{height: `${end}px`}
			], {
				duration: 250,
				easing: "ease"
			});
		}
	},
	mounted() {
		window.addEventListener("resize", () => this.screenWidth = window.innerWidth);
	},
};
